import React from 'react';
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaYoutube,
  FaInstagram,
} from 'react-icons/fa';
import { get } from 'lodash';
import parseRichText from '../../utils/parseRichText';

import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import RichTextRender, { styledBlocks, elementsExist } from '../../components/RichTextRender';
import { ServicePageColors } from '../../components/Theme.jsx';

import './Footer.scss';

import EliteLogoAubergine from '../../assets/elite_aubergine.svg';
import profileLogo from '../../assets/profile_logo_white.svg';
import profileLogoAubergine from '../../assets/profile-logo-eggplant.svg';

const Footer = ({ partnerLegalName, sectionData }) => {
  const quickLinks = get(sectionData, 'quickLinks', []);
  const contactUs = get(sectionData, 'contactUs.raw');
  const topParagraph = get(sectionData, 'topParagraph.raw');
  const bottomParagraph = get(sectionData, 'bottomParagraph.raw');
  const colour = get(sectionData, 'colour', 'midnight');

  const theme = ServicePageColors[colour] ? ServicePageColors[colour] : ServicePageColors.paleSlate;

  const ContactUsHeadingFive = ({ children }) => elementsExist(children) ? <h5 className={`${theme.contentColor} heading`}>{children}</h5> : null;
  const ContactUsText = ({ children }) => elementsExist(children) ? <p className={`${theme.contentColor} text`}>{children}</p> : <br />;

  const getLogo = () => {
    const lightColours = ['white', 'pale-piggy', 'grey', 'mint', 'pale-slate'];
    return lightColours.includes(colour) ? profileLogoAubergine : profileLogo;
  };

  return (
    <footer className={`${theme.backgroundColor}`}>
      <div className='footer-container'>
        <div className='logo-container'>
          <img className='logo' src={getLogo()} alt="Profile Pensions Logo" />
        </div>
        <div className='wrapper-disclaimer'>
          {documentToReactComponents(parseRichText(topParagraph), RichTextRender(styledBlocks(`${theme.contentColor} disclaimer`)))}
        </div>
        <div className='wrapper-social-links'>
          <div className='links'>
            <a aria-label="facebook" className={'icon social fb'} href="https://www.facebook.com/ProfilePensions/" rel="noopener noreferrer" target="_blank" >
              <FaFacebookF />
            </a>
            <a aria-label="Twitter" className={'icon social tw'} href="https://twitter.com/profilepensions" rel="noopener noreferrer" target="_blank" >
              <FaTwitter />
            </a>
            <a aria-label="Linkedin" className={'icon social li'} href="https://www.linkedin.com/company/profile-financial-solutions-ltd/" rel="noopener noreferrer" target="_blank" >
              <FaLinkedinIn />
            </a>
            <a aria-label="Youtube" className={'icon social yt'} href="https://www.youtube.com/channel/UCKHQgf2MbLUDhI5mJztgcpA/" rel="noopener noreferrer" target="_blank" >
              <FaYoutube />
            </a>
            <a aria-label="Instagram" className={'icon social in'} href="https://www.instagram.com/profilepensions/" rel="noopener noreferrer" target="_blank" >
              <FaInstagram />
            </a>
          </div>
        </div>
        <div className='wrapper-quick-links'>
          <h5 className={`${theme.contentColor} heading`}>QUICK LINKS</h5>
          <ul className='list'>
            {quickLinks.map(quickLink => (
              <li className='link-item' key={quickLink.displayText}>
                <a className={`${theme.contentColor} link`} href={quickLink.url} rel="noopener noreferrer" target="_blank">{quickLink.displayText}</a>
              </li>))}
            <li className='link-item' key="cookies-preferences">
              <button className={`${theme.contentColor} link link-button`} onClick={() => {
                window.CookieControl.hide();
                window.CookieControl.open();
              }}>Managing Cookies Preferences</button>
            </li>
          </ul>
        </div>
        <div className='wrapper-contact'>
          {documentToReactComponents(parseRichText(contactUs), RichTextRender({
            ...styledBlocks(`${theme.contentColor}`),
            HeadingFive: ContactUsHeadingFive,
            Text: ContactUsText,
          }))}
        </div>
        <div className='wrapper-security'>
          <div id="DigiCertClickID_lcBSnm6k" className='digicert' />
          <div id="FSCS" className='fscs'>
            <a href="https://www.fscs.org.uk/what-we-cover/pensions/" rel="noopener noreferrer" target="_blank">
              <img src={profileLogoAubergine} alt="FSCS Protected" />
            </a>
          </div>
          <div id="Elite" className='eliteicon'>
            <a href="https://www.elite-network.com/private-companies/our-companies/profile-pensions" rel="noopener noreferrer" target="_blank">
              <img src={EliteLogoAubergine} alt="Elite Company" />
            </a>
          </div>
        </div>
        <div className='wrapper-small-print'>
          {
            partnerLegalName
              ? (
                <React.Fragment>
                  <p className={`small-print ${theme.contentColor}`}>{`${partnerLegalName} is an Introducer Appointed Representative of Profile Pensions. `}</p>
                  {documentToReactComponents(parseRichText(bottomParagraph), RichTextRender(styledBlocks(`${theme.contentColor} small-print`)))}
                </React.Fragment>
              )
              : documentToReactComponents(parseRichText(bottomParagraph), RichTextRender(styledBlocks(`${theme.contentColor} small-print`)))
          }
        </div>
      </div>
    </footer>
  );
};

export default Footer;
